import './App.css';
import HeaderBanner from './Components/Banner/Banner';
import Footer from './Components/Footer/Footer';
import Navbar from './Components/Navbar/Navbar';
import News from './Components/News/News';
import ProductCards from './Components/ProductsCards/ProductCards';
import Testimonial from './Components/Testimonial/Testimonial';


function App() {
  return (
    <>
      <Navbar />
      <HeaderBanner />
      <ProductCards />
      <Testimonial />
      <News />
      <Footer />

    </>
  );
}

export default App;
